import $ from 'jquery';
import gracefulErrorHandler from './error';

const query = decodeURIComponent(window.utf8Query);
let p = 2;

/**
 * qsearch1에서 동영상 목록을 불러온다.
 * @returns {jQuery.Deferred}
 */
function fetchClips() {
  const params = {
    q: query,
    w: 'spread',
    m: 'vclip_vod',
    exp: 'VO2',
    n: 5,
    p,
    dup_filter: 'y',
    qsearch_ver: 'v2',
    viewtype: 'json'
  };
  const qsearchURL = SF.getQsUrl(params, 1);
  /* eslint-disable */
  return $.getJSON(qsearchURL)
    .then(
      unwrapResponse,
      gracefulErrorHandler
    )
    .fail(err => console.error(err));
  /* eslint-enable */
}

function unwrapResponse(res) {
  const json = typeof res === 'string' ? JSON.parse(res) : res;
  const {r} = json.RESULT.SPREAD_VCLIP_VOD;
  const data = r.ds.data || [];

  incrementPageParam();
  return {
    data: Array.isArray(data) ? data : [data],
    isEnd: r.m.is_end.toLowerCase() === 'true'
  };
}

function incrementPageParam() {
  p++;
}

export default fetchClips;


/** WEBPACK FOOTER **
 ** ./src/VO2/libs/api/fetch-clips.js
 **/